module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/us@3x.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/us@3x.png
// module id = 1193
// module chunks = 0